module.exports = __webpack_public_path__ + "static/img/streamgraphmaker.ebbd5e3d.jpg";